// extracted by mini-css-extract-plugin
module.exports = {"logo":"footer-module--logo--LCv7Q","copyright":"footer-module--copyright--4FyNV","menuFooter":"footer-module--menuFooter--F73IS"};